import { render, staticRenderFns } from "./UpdatePasswordModal.vue?vue&type=template&id=2f559387&scoped=true&"
import script from "./UpdatePasswordModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordModal.vue?vue&type=style&index=0&id=2f559387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f559387",
  null
  
)

export default component.exports